import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorage } from '@ngx-pwa/local-storage';
import { title } from 'process';
import { SenaceService } from 'src/app/services/senace.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-url-externa',
  templateUrl: './url-externa.component.html',
  styleUrls: ['./url-externa.component.css']
})
export class UrlExternaComponent implements OnInit {
  encontrado = true;
  msg: string = "";
  siglaExpediente : string = "";
  
  constructor(
    private route: ActivatedRoute,
    private senaceService: SenaceService,
    private localStorage: LocalStorage,
    private router: Router
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.senaceService.getExpedientePorUID(params['uid'])
        .subscribe(
          (resp) => {
            if (!resp.Result.expediente) {
              this.encontrado = false;
              this.msg = 'No se ha encontrado el expediente solicitado.';
              Swal.fire({
                title: `Aviso`,
                text: this.msg,
                icon: 'warning'
              })
              return;
            } else {
              Swal.close();
              Swal.fire({
                text: 'Consultando ...',
                icon: 'info',
                showCancelButton: false,
                allowOutsideClick: false,
              });
              Swal.showLoading();
              this.senaceService.getDetalleExpediente(resp.Result.expediente)
                .subscribe(
                  (respuesta) => {
                    Swal.close();
                    if (respuesta) {
                      if (!respuesta.error) {
                        respuesta["expedienteId"] = resp.Result.idExpediente;
                        
                        respuesta['menu'] = this.prepararMenu(respuesta);
                        
                        // Para la URL 
                        respuesta['url'] = this.senaceService.getUrlUId(params['uid']);

                        // respuesta["estudio"] = this.formulario.get('tipoestudio').value;
                        respuesta['participacion'] = resp.Result.enAporte;       
                        
                        console.log(respuesta);

                        this.localStorage.setItem(`detalle`, respuesta).subscribe(
                          (resp) => {
                            this.router.navigate(['/estudio']);
                          }
                        );
                      } else {
                        Swal.fire({
                          title: `Aviso`,
                          text: respuesta.error,
                          icon: 'error',
                          confirmButtonText: 'Aceptar'
                        })
                      }
                    }
                  },
                  (error) => {
                    if (error.status === 200) {
                      Swal.fire({
                        title: `Código error: ${error.status}`,
                        text: `El expediente ${resp.Result.expediente} contiene una estructura JSON inválido.`,
                        icon: 'warning',
                        confirmButtonText: 'Aceptar'
                      });
                      return;
                    }
                    Swal.fire({
                      title: `Error: ${error.status}`,
                      text: 'Error al consultar el expediente. Intente nuevamente',
                      icon: 'error',
                      confirmButtonText: 'Aceptar'
                    })
                  }
                )
            }

          },
          (error) => {
            this.encontrado = false;
            this.msg = `Error: ${error.status}.Error al consultar la información.`
            Swal.fire({
              title: `Error ${error.status}`,
              text: 'Error al consultar la información.',
              icon: 'error'
            })
          }
        )
    });
  }  

  // Preparar menu modulo
  private prepararMenu(data: any) {    

    let menu = {
      datosGenerales: true,
      seguimientoProyecto: true,
      areasEfectivas: false,
      descripcionProyecto: false,
      lineaBase: false,
      participacionCiudadana: false,
      impactoAmbiental: false,
      manejoAmbiental: false,
      valoracionEconomica: false,
      mapaGeneral: false
    };
    if (data.solicitud) {
      for (const keySolicitud in data.solicitud) {
        if (keySolicitud === 'secciones') {
          for (const keySeccion in data.solicitud.secciones) {
            let secciones = data.solicitud.secciones[keySeccion];
            for (const keyCapitulos in secciones) {
              if (keyCapitulos === 'capitulos') {
                let capitulos = secciones['capitulos'];
                for (const keyDatos in capitulos) {
                  let datos = capitulos[keyDatos];
                  for (const keySubDatos in datos['datos']) {

                    /*================================================
                    =            Areas Efectivas            =
                    ================================================*/
                    if (keySubDatos === 'areaEfectivaProyecto') { menu.areasEfectivas = true; menu.mapaGeneral = true; } //[]

                    /*================================================
                    =            Descripcion del Proyecto            =
                    ================================================*/
                    if (keySubDatos === 'estudioPrevioAprobado') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'permisosVigentes') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'componentes') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'empleo') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'insumos') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'usoAgua') { menu.descripcionProyecto = true; } //[]
                    if (keySubDatos === 'efluentes') { menu.descripcionProyecto = true; } //[]

                    /*================================================
                    =            Linea Base            =
                    ================================================*/
                    if (keySubDatos === 'clima') { menu.lineaBase = true; }
                    if (keySubDatos === 'estacionesMeteorologicas') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'fuentesAgua') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'estacionesMuestreo') { menu.lineaBase = true; } //[]
                    if (keySubDatos === 'aspectoPoblacion') { menu.lineaBase = true; } //[]

                    /*================================================
                    =            Participación Ciudadana            =
                    ================================================*/
                    if (keySubDatos === 'registroActividades') { menu.participacionCiudadana = true; } //[]


                    if (keySubDatos === 'manejoAmbiental' || keySubDatos === 'compromisoSocial' || keySubDatos === 'programaMonitoreo') {  //[]
                      // menu.participacionCiudadana = true; 

                      // let datoManejoAmb = datos['datos']['manejoAmbiental'];
                      let datoManejoAmb = datos['datos'][keySubDatos];

                      for (const keyManejoAmb in datoManejoAmb) {
                        let lectura = datoManejoAmb[keyManejoAmb];
                        for (const keyManejos in lectura) {

                          /*================================================
                          =            Impacto Ambiental            =
                          ================================================*/
                          if (keyManejos === 'medios') { menu.impactoAmbiental = true; } //[]

                          /*================================================
                          =            Manejo Ambiental            =
                          ================================================*/
                          if (keyManejos === 'manejosAmbientales' || keyManejos === 'compromisosSociales' || keyManejos === 'identificacionPunto') { menu.manejoAmbiental = true; } //[]


                        }
                      }
                    }

                    /*================================================
                    =            Valoración Económica            =
                    ================================================*/
                    if (keySubDatos === 'valoracionEconomica') {  //[]
                      menu.valoracionEconomica = true;
                    }

                  }
                }
              }
            }
          }
        }
      }
    }
    return menu;
  }

}
